<div class="card mb-2">
  <a
    class="card-body cursor-pointer text-dark"
    [routerLink]="activity.route"
    [queryParams]="activity.queryParams ? activity.queryParams : null"
    [fragment]="activity.activityCode"
    (click)="activity.action ? activity.action() : null"
  >
    <h5 class="card-title d-flex align-items-center"><i class="mr-2 text-primary fs-28" [ngClass]="activity.icon"></i>{{ activity.title }}</h5>
    <p class="card-text font-weight-light mb-1" *ngIf="activity.description">
      {{ activity.shortDescription }}
    </p>

    <div class="mb-2" *ngIf="environment.clientId === 'rubbl.admin'" [ngSwitch]="activity.activityCode">
      <ng-container *ngSwitchCase="'MACHINE-AVAILABILITY'">
        <span class="badge badge-pill badge-success mr-2" *ngIf="activity.activityResponse === 'true'">Available</span>
        <span class="badge badge-pill badge-primary mr-2" *ngIf="activity.activityResponse === 'false'">Not Available</span>
        <ng-container *ngIf="activity.activityResponse === 'true'">
          <span class="badge badge-pill badge-success" *ngIf="activity.metadata?.canProvideTransport === 'true'"
            ><ng-container *ngIf="activity.metadata?.transportQuote != null">
              {{ activity.metadata.transportQuote | currency : "USD" : "symbol" : "1.0-0" }}
            </ng-container>
            <ng-container *ngIf="activity.metadata?.transportQuote == null"> Transport </ng-container>
          </span>
          <span class="badge badge-pill badge-primary" *ngIf="activity.metadata?.canProvideTransport === 'false'">Transport</span>
        </ng-container>
      </ng-container>
    </div>

    <div>
      <small class="text-muted mr-auto" *ngIf="activity.createdDateTime">Created on {{ activity.createdDateTime | date : "MMM d, h:mm a" }} </small>
    </div>

    <div>
      <small class="text-muted mr-auto" *ngIf="activity.completedDateTime">Completed on {{ activity.completedDateTime | date : "MMM d, h:mm a" }} </small>
    </div>
  </a>
  <div class="list-group list-group-flush" *ngIf="activity.status">
    <div class="px-3 py-2 d-flex align-items-center">
      <div class="mr-auto"><common-status-label [status]="activity.status" labelStyle="status-pill"></common-status-label></div>

      <a *ngIf="!activity.required && activity.status != 'Dismissed'" href="#" (click)="dismiss()" class="card-link">Dismiss</a>
      <small *ngIf="activity.required" class="badge-outline-primary badge font-weight-light">
        <span *ngIf="environment.clientId == 'rubbl.admin'">{{ activity.capabilityType }} </span>Required</small
      >
    </div>
  </div>
</div>
